import {Skeleton} from "@mui/material";
import React, {useContext} from "react";
import {IsDarkThemeOnContext} from "../../App";

const Loader = () => {
    const isDarkThemeOn = useContext(IsDarkThemeOnContext);
    const skeletonColor = {bgcolor: isDarkThemeOn ? '#FEF7F8' : '#E2E8F0'}
    
    return <div className={"human-call-score-report-loader"} style={{display: "flex", flexDirection: "column", gap: '24px', margin: '24px 0'}}>
        <div className={"summary"}>
            <Skeleton sx={skeletonColor} animation="wave" height={20}/>
            <Skeleton sx={skeletonColor} animation="wave" height={20}/>
            <Skeleton sx={skeletonColor} animation="wave" height={20}/>
            <Skeleton sx={skeletonColor} animation="wave" height={20} width={"50%"}/>
        </div>
        <div style={{display: "flex", gap: "16px"}}  className={"call-score-factors"}>

            <div style={{height: "55px", flex: 1, color: "white", borderRadius: "8px", border: "1px solid #E2E8F0", padding: "6px", display: "flex", justifyContent:"center", flexDirection: "column"}}>
                <Skeleton sx={skeletonColor} animation="wave" width={"100%"}/>
                <Skeleton sx={skeletonColor} animation="wave" width={"50%"}/>
            </div>

            <div style={{height: "55px", flex: 3, color: "white", borderRadius: "8px", border: "1px solid #E2E8F0", padding: "6px", display: "flex", justifyContent:"center", flexDirection: "column"}}>
                <Skeleton sx={skeletonColor} animation="wave" width={"100%"}/>
                <Skeleton sx={skeletonColor} animation="wave" width={"50%"}/>
            </div>
            <div style={{height: "55px", flex: 3, color: "white", borderRadius: "8px", border: "1px solid #E2E8F0", padding: "6px", display: "flex", justifyContent:"center", flexDirection: "column"}}>
                <Skeleton sx={skeletonColor} animation="wave" width={"100%"}/>
                <Skeleton sx={skeletonColor} animation="wave" width={"50%"}/>
            </div>
        </div>
        <div style={{height: "200px", color: "white", borderRadius: "8px", border: "1px solid #E2E8F0", padding: "16px", display: "flex", justifyContent:"center", flexDirection: "column", gap: "12px"}}   className={"call-score-factors-details"}>
            <div className={"factor-title-and-score"}>
                <Skeleton sx={skeletonColor} animation="wave" height={40} width={"30%"}/>
                <Skeleton sx={skeletonColor} animation="wave" height={40} width={"5%"}/>
            </div>

            <Skeleton sx={skeletonColor} animation="wave" height={30} width={"40%"}/>
            <Skeleton sx={skeletonColor} animation="wave" height={20} />
            <Skeleton sx={skeletonColor} animation="wave" height={20} />
            <Skeleton sx={skeletonColor} animation="wave" height={20} width={"50%"}/>
        </div>

        <div style={{height: "200px", color: "white", borderRadius: "8px", border: "1px solid #E2E8F0", padding: "16px", display: "flex", justifyContent:"center", flexDirection: "column", gap: "12px"}} >
            <div>
                <Skeleton sx={skeletonColor} animation="wave" height={40} width={"30%"}/>
                <Skeleton sx={skeletonColor} animation="wave" height={40} width={"5%"}/>
            </div>

            <Skeleton sx={skeletonColor} animation="wave" height={30} width={"40%"}/>
            <Skeleton sx={skeletonColor} animation="wave" height={20} />
            <Skeleton sx={skeletonColor} animation="wave" height={20} />
            <Skeleton sx={skeletonColor} animation="wave" height={20} width={"50%"}/>
        </div>
    </div>
}

export default Loader;